import React from 'react'

export default (props) => <span className={`store-icon store-icon-${props.code}`} />
